import { MessageCircle } from "lucide-react";

export function WhatsAppLink({ number, message = "", className = "" }) {
  if (!number) return null;
  const digits = String(number).replace(/\D/g, "");
  if (!digits) return null;
  const full = digits.startsWith("39") ? digits : (digits.length >= 9 && digits.length <= 11 ? "39" + digits : digits);
  const href = `https://wa.me/${full}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Invia messaggio WhatsApp"
      data-testid="whatsapp-link"
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-600 hover:bg-emerald-500/20 transition-colors ${className}`}
    >
      <MessageCircle className="h-3.5 w-3.5" />
    </a>
  );
}
